// Country codes and flags utility for phone number input
// Based on the React implementation from idx-core

import { parsePhoneNumberFromString, CountryCode } from "libphonenumber-js";
import { translate } from "tbme/localization";

export interface CountryInfo {
  name: string;
  code: string;
  flag: string;
}

export const countries: readonly CountryInfo[] = Object.freeze([
  { name: "US", code: "1", flag: "🇺🇸" },
  { name: "AF", code: "93", flag: "🇦🇫" },
  { name: "AX", code: "358", flag: "🇦🇽" },
  { name: "AL", code: "355", flag: "🇦🇱" },
  { name: "DZ", code: "213", flag: "🇩🇿" },
  { name: "AS", code: "1", flag: "🇦🇸" },
  { name: "AD", code: "376", flag: "🇦🇩" },
  { name: "AI", code: "1", flag: "🇦🇮" },
  { name: "AQ", code: "672", flag: "🇦🇶" },
  { name: "AG", code: "1", flag: "🇦🇬" },
  { name: "AR", code: "54", flag: "🇦🇷" },
  { name: "AM", code: "374", flag: "🇦🇲" },
  { name: "AW", code: "297", flag: "🇦🇼" },
  { name: "AU", code: "61", flag: "🇦🇺" },
  { name: "AT", code: "43", flag: "🇦🇹" },
  { name: "AZ", code: "994", flag: "🇦🇿" },
  { name: "BS", code: "1", flag: "🇧🇸" },
  { name: "BH", code: "973", flag: "🇧🇭" },
  { name: "BD", code: "880", flag: "🇧🇩" },
  { name: "BB", code: "1", flag: "🇧🇧" },
  { name: "BY", code: "375", flag: "🇧🇾" },
  { name: "BE", code: "32", flag: "🇧🇪" },
  { name: "BZ", code: "501", flag: "🇧🇿" },
  { name: "BJ", code: "229", flag: "🇧🇯" },
  { name: "BM", code: "1", flag: "🇧🇲" },
  { name: "BT", code: "975", flag: "🇧🇹" },
  { name: "BO", code: "591", flag: "🇧🇴" },
  { name: "BA", code: "387", flag: "🇧🇦" },
  { name: "BW", code: "267", flag: "🇧🇼" },
  { name: "BR", code: "55", flag: "🇧🇷" },
  { name: "IO", code: "246", flag: "🇮🇴" },
  { name: "BN", code: "673", flag: "🇧🇳" },
  { name: "BG", code: "359", flag: "🇧🇬" },
  { name: "BF", code: "226", flag: "🇧🇫" },
  { name: "BI", code: "257", flag: "🇧🇮" },
  { name: "KH", code: "855", flag: "🇰🇭" },
  { name: "CM", code: "237", flag: "🇨🇲" },
  { name: "CA", code: "1", flag: "🇨🇦" },
  { name: "CV", code: "238", flag: "🇨🇻" },
  { name: "KY", code: "1", flag: "🇰🇾" },
  { name: "CF", code: "236", flag: "🇨🇫" },
  { name: "TD", code: "235", flag: "🇹🇩" },
  { name: "CL", code: "56", flag: "🇨🇱" },
  { name: "CN", code: "86", flag: "🇨🇳" },
  { name: "CX", code: "61", flag: "🇨🇽" },
  { name: "CC", code: "61", flag: "🇨🇨" },
  { name: "CO", code: "57", flag: "🇨🇴" },
  { name: "KM", code: "269", flag: "🇰🇲" },
  { name: "CG", code: "242", flag: "🇨🇬" },
  { name: "CD", code: "243", flag: "🇨🇩" },
  { name: "CK", code: "682", flag: "🇨🇰" },
  { name: "CR", code: "506", flag: "🇨🇷" },
  { name: "CI", code: "225", flag: "🇨🇮" },
  { name: "HR", code: "385", flag: "🇭🇷" },
  { name: "CY", code: "357", flag: "🇨🇾" },
  { name: "CZ", code: "420", flag: "🇨🇿" },
  { name: "DK", code: "45", flag: "🇩🇰" },
  { name: "DJ", code: "253", flag: "🇩🇯" },
  { name: "DM", code: "1", flag: "🇩🇲" },
  { name: "DO", code: "1", flag: "🇩🇴" },
  { name: "EC", code: "593", flag: "🇪🇨" },
  { name: "EG", code: "20", flag: "🇪🇬" },
  { name: "SV", code: "503", flag: "🇸🇻" },
  { name: "GQ", code: "240", flag: "🇬🇶" },
  { name: "ER", code: "291", flag: "🇪🇷" },
  { name: "EE", code: "372", flag: "🇪🇪" },
  { name: "ET", code: "251", flag: "🇪🇹" },
  { name: "FK", code: "500", flag: "🇫🇰" },
  { name: "FO", code: "298", flag: "🇫🇴" },
  { name: "FJ", code: "679", flag: "🇫🇯" },
  { name: "FI", code: "358", flag: "🇫🇮" },
  { name: "FR", code: "33", flag: "🇫🇷" },
  { name: "GF", code: "594", flag: "🇬🇫" },
  { name: "PF", code: "689", flag: "🇵🇫" },
  { name: "TF", code: "262", flag: "🇹🇫" },
  { name: "GA", code: "241", flag: "🇬🇦" },
  { name: "GM", code: "220", flag: "🇬🇲" },
  { name: "GE", code: "995", flag: "🇬🇪" },
  { name: "DE", code: "49", flag: "🇩🇪" },
  { name: "GH", code: "233", flag: "🇬🇭" },
  { name: "GI", code: "350", flag: "🇬🇮" },
  { name: "GR", code: "30", flag: "🇬🇷" },
  { name: "GL", code: "299", flag: "🇬🇱" },
  { name: "GD", code: "1", flag: "🇬🇩" },
  { name: "GP", code: "590", flag: "🇬🇵" },
  { name: "GU", code: "1", flag: "🇬🇺" },
  { name: "GT", code: "502", flag: "🇬🇹" },
  { name: "GN", code: "224", flag: "🇬🇳" },
  { name: "GW", code: "245", flag: "🇬🇼" },
  { name: "GY", code: "592", flag: "🇬🇾" },
  { name: "HT", code: "509", flag: "🇭🇹" },
  { name: "HM", code: "672", flag: "🇭🇲" },
  { name: "VA", code: "379", flag: "🇻🇦" },
  { name: "HK", code: "852", flag: "🇭🇰" },
  { name: "HN", code: "504", flag: "🇭🇳" },
  { name: "HU", code: "36", flag: "🇭🇺" },
  { name: "IS", code: "354", flag: "🇮🇸" },
  { name: "IN", code: "91", flag: "🇮🇳" },
  { name: "ID", code: "62", flag: "🇮🇩" },
  { name: "IE", code: "353", flag: "🇮🇪" },
  { name: "IL", code: "972", flag: "🇮🇱" },
  { name: "IT", code: "39", flag: "🇮🇹" },
  { name: "JM", code: "1", flag: "🇯🇲" },
  { name: "JP", code: "81", flag: "🇯🇵" },
  { name: "JO", code: "962", flag: "🇯🇴" },
  { name: "KZ", code: "7", flag: "🇰🇿" },
  { name: "KE", code: "254", flag: "🇰🇪" },
  { name: "KI", code: "686", flag: "🇰🇮" },
  { name: "KR", code: "82", flag: "🇰🇷" },
  { name: "KW", code: "965", flag: "🇰🇼" },
  { name: "KG", code: "996", flag: "🇰🇬" },
  { name: "LA", code: "856", flag: "🇱🇦" },
  { name: "LV", code: "371", flag: "🇱🇻" },
  { name: "LB", code: "961", flag: "🇱🇧" },
  { name: "LS", code: "266", flag: "🇱🇸" },
  { name: "LR", code: "231", flag: "🇱🇷" },
  { name: "LI", code: "423", flag: "🇱🇮" },
  { name: "LT", code: "370", flag: "🇱🇹" },
  { name: "LU", code: "352", flag: "🇱🇺" },
  { name: "MO", code: "853", flag: "🇲🇴" },
  { name: "MK", code: "389", flag: "🇲🇰" },
  { name: "MG", code: "261", flag: "🇲🇬" },
  { name: "MW", code: "265", flag: "🇲🇼" },
  { name: "MY", code: "60", flag: "🇲🇾" },
  { name: "MV", code: "960", flag: "🇲🇻" },
  { name: "ML", code: "223", flag: "🇲🇱" },
  { name: "MT", code: "356", flag: "🇲🇹" },
  { name: "MH", code: "692", flag: "🇲🇭" },
  { name: "MQ", code: "596", flag: "🇲🇶" },
  { name: "MR", code: "222", flag: "🇲🇷" },
  { name: "MU", code: "230", flag: "🇲🇺" },
  { name: "YT", code: "262", flag: "🇾🇹" },
  { name: "MX", code: "52", flag: "🇲🇽" },
  { name: "FM", code: "691", flag: "🇫🇲" },
  { name: "MD", code: "373", flag: "🇲🇩" },
  { name: "MC", code: "377", flag: "🇲🇨" },
  { name: "MN", code: "976", flag: "🇲🇳" },
  { name: "MS", code: "1", flag: "🇲🇸" },
  { name: "MA", code: "212", flag: "🇲🇦" },
  { name: "MZ", code: "258", flag: "🇲🇿" },
  { name: "MM", code: "95", flag: "🇲🇲" },
  { name: "NA", code: "264", flag: "🇳🇦" },
  { name: "NR", code: "674", flag: "🇳🇷" },
  { name: "NP", code: "977", flag: "🇳🇵" },
  { name: "NL", code: "31", flag: "🇳🇱" },
  { name: "AN", code: "599", flag: "🇧🇶" },
  { name: "NC", code: "687", flag: "🇳🇨" },
  { name: "NZ", code: "64", flag: "🇳🇿" },
  { name: "NI", code: "505", flag: "🇳🇮" },
  { name: "NE", code: "227", flag: "🇳🇪" },
  { name: "NG", code: "234", flag: "🇳🇬" },
  { name: "NU", code: "683", flag: "🇳🇺" },
  { name: "NF", code: "672", flag: "🇳🇫" },
  { name: "MP", code: "1", flag: "🇲🇵" },
  { name: "NO", code: "47", flag: "🇳🇴" },
  { name: "OM", code: "968", flag: "🇴🇲" },
  { name: "PK", code: "92", flag: "🇵🇰" },
  { name: "PW", code: "680", flag: "🇵🇼" },
  { name: "PS", code: "970", flag: "🇵🇸" },
  { name: "PA", code: "507", flag: "🇵🇦" },
  { name: "PG", code: "675", flag: "🇵🇬" },
  { name: "PY", code: "595", flag: "🇵🇾" },
  { name: "PE", code: "51", flag: "🇵🇪" },
  { name: "PH", code: "63", flag: "🇵🇭" },
  { name: "PN", code: "64", flag: "🇵🇳" },
  { name: "PL", code: "48", flag: "🇵🇱" },
  { name: "PT", code: "351", flag: "🇵🇹" },
  { name: "PR", code: "1", flag: "🇵🇷" },
  { name: "QA", code: "974", flag: "🇶🇦" },
  { name: "RE", code: "262", flag: "🇷🇪" },
  { name: "RO", code: "40", flag: "🇷🇴" },
  { name: "RU", code: "7", flag: "🇷🇺" },
  { name: "RW", code: "250", flag: "🇷🇼" },
  { name: "SH", code: "290", flag: "🇸🇭" },
  { name: "KN", code: "1", flag: "🇰🇳" },
  { name: "LC", code: "1", flag: "🇱🇨" },
  { name: "PM", code: "508", flag: "🇵🇲" },
  { name: "VC", code: "1", flag: "🇻🇨" },
  { name: "WS", code: "685", flag: "🇼🇸" },
  { name: "SM", code: "378", flag: "🇸🇲" },
  { name: "ST", code: "239", flag: "🇸🇹" },
  { name: "SA", code: "966", flag: "🇸🇦" },
  { name: "SN", code: "221", flag: "🇸🇳" },
  { name: "RS", code: "381", flag: "🇷🇸" },
  { name: "SC", code: "248", flag: "🇸🇨" },
  { name: "SL", code: "232", flag: "🇸🇱" },
  { name: "SG", code: "65", flag: "🇸🇬" },
  { name: "SK", code: "421", flag: "🇸🇰" },
  { name: "SI", code: "386", flag: "🇸🇮" },
  { name: "SB", code: "677", flag: "🇸🇧" },
  { name: "SO", code: "252", flag: "🇸🇴" },
  { name: "ZA", code: "27", flag: "🇿🇦" },
  { name: "GS", code: "500", flag: "🇬🇸" },
  { name: "ES", code: "34", flag: "🇪🇸" },
  { name: "LK", code: "94", flag: "🇱🇰" },
  { name: "SR", code: "597", flag: "🇸🇷" },
  { name: "SJ", code: "47", flag: "🇸🇯" },
  { name: "SZ", code: "268", flag: "🇸🇿" },
  { name: "SE", code: "46", flag: "🇸🇪" },
  { name: "CH", code: "41", flag: "🇨🇭" },
  { name: "TW", code: "886", flag: "🇹🇼" },
  { name: "TJ", code: "992", flag: "🇹🇯" },
  { name: "TZ", code: "255", flag: "🇹🇿" },
  { name: "TH", code: "66", flag: "🇹🇭" },
  { name: "TL", code: "670", flag: "🇹🇱" },
  { name: "TG", code: "228", flag: "🇹🇬" },
  { name: "TK", code: "690", flag: "🇹🇰" },
  { name: "TO", code: "676", flag: "🇹🇴" },
  { name: "TT", code: "1", flag: "🇹🇹" },
  { name: "TN", code: "216", flag: "🇹🇳" },
  { name: "TR", code: "90", flag: "🇹🇷" },
  { name: "TM", code: "993", flag: "🇹🇲" },
  { name: "TC", code: "1", flag: "🇹🇨" },
  { name: "TV", code: "688", flag: "🇹🇻" },
  { name: "UG", code: "256", flag: "🇺🇬" },
  { name: "UA", code: "380", flag: "🇺🇦" },
  { name: "AE", code: "971", flag: "🇦🇪" },
  { name: "GB", code: "44", flag: "🇬🇧" },
  { name: "UM", code: "1", flag: "🇺🇸" },
  { name: "UY", code: "598", flag: "🇺🇾" },
  { name: "UZ", code: "998", flag: "🇺🇿" },
  { name: "VU", code: "678", flag: "🇻🇺" },
  { name: "VE", code: "58", flag: "🇻🇪" },
  { name: "VN", code: "84", flag: "🇻🇳" },
  { name: "VG", code: "1", flag: "🇻🇬" },
  { name: "VI", code: "1", flag: "🇻🇮" },
  { name: "WF", code: "681", flag: "🇼🇫" },
  { name: "EH", code: "212", flag: "🇪🇭" },
  { name: "YE", code: "967", flag: "🇾🇪" },
  { name: "ZM", code: "260", flag: "🇿🇲" },
  { name: "ZW", code: "263", flag: "🇿🇼" },
]);

// Country lookup maps for performance
const countryToFlagAndCode = new Map(
  countries.map((country) => [
    country.name,
    { code: country.code, flag: country.flag },
  ])
);

const codeToCountry = new Map(
  countries.map((country) => [country.code, country])
);

// Cache for country select options
let _countrySelectOptions: Array<{
  label: string;
  value: string;
}> | null = null;

export function getFlagAndCodeForCountry(
  countryName: string
): { code: string; flag: string } {
  return countryToFlagAndCode.get(countryName) || { code: "1", flag: "🇺🇸" };
}

export function findCountryByCode(
  countryCode: string
): CountryInfo | undefined {
  return codeToCountry.get(countryCode);
}

/**
 * Gets the localized country name for a given country code
 * @param countryCode - The country code (e.g., "US", "GB", "CA")
 * @returns The localized country name
 */
function getLocalizedCountryName(countryCode: string): string {
  try {
    // Use the translation system to get the localized country name
    const translatedName = translate(`countries.${countryCode}`);

    // Check if we got a "missing translation" error message
    if (
      translatedName &&
      !translatedName.includes("[missing") &&
      !translatedName.includes("translation]")
    ) {
      return translatedName;
    }

    // Fallback to a formatted version of the country code
    return countryCode;
  } catch (error) {
    // Fallback to the country code if translation fails
    return countryCode;
  }
}

export function getCountrySelectOptions(): Array<{
  label: string;
  value: string;
}> {
  if (!_countrySelectOptions) {
    _countrySelectOptions = countries.map((country) => {
      const countryDisplayName = getLocalizedCountryName(country.name);
      return {
        label: `${countryDisplayName} (+${country.code})`,
        value: country.name,
      };
    });
  }
  return _countrySelectOptions;
}

/**
 * Normalizes a phone number by ensuring it has the correct country code prefix
 * @param phoneNumber - The phone number to normalize
 * @param countryName - The country name (e.g. "US", "GB")
 * @returns The normalized phone number
 */
export function normalizePhoneNumber(
  phoneNumber: string,
  countryName: string
): string {
  if (!phoneNumber) {
    return "";
  }

  // If already has country code, return as-is
  if (RegExp(`^(\\+)`).test(phoneNumber)) {
    return phoneNumber;
  }

  try {
    const phone = parsePhoneNumberFromString(
      phoneNumber,
      countryName as CountryCode
    );

    if (phone?.isValid()) {
      return phone.number;
    }

    // If parsing fails, try to construct a reasonable format
    // Get the country code for the selected country
    const countryInfo = findCountryByCode(
      getFlagAndCodeForCountry(countryName).code
    );
    if (countryInfo) {
      const cleanedNumber = phoneNumber.replace(/[^\d]/g, "");
      if (cleanedNumber.length > 0) {
        return `+${countryInfo.code}${cleanedNumber}`;
      }
    }

    return phoneNumber;
  } catch (error) {
    // On error, return the original number
    return phoneNumber;
  }
}

/**
 * Decomposes a full phone number into country and phone number parts
 */
export function decomposePhoneNumber(
  fullPhoneNumber: string
): {
  countryName: string;
  phoneNumber: string;
} {
  if (!fullPhoneNumber) {
    return { countryName: "US", phoneNumber: "" };
  }

  // Remove + and spaces to get clean number
  const cleaned = fullPhoneNumber.replace(/[+\s]/g, "");

  // Try to find matching country code (longest match first)
  const sortedCountries = [...countries].sort(
    (a, b) => b.code.length - a.code.length
  );

  for (const country of sortedCountries) {
    if (cleaned.startsWith(country.code)) {
      const phoneNumber = cleaned.substring(country.code.length);
      return {
        countryName: country.name,
        phoneNumber: phoneNumber,
      };
    }
  }

  // Default to US if no match found
  return { countryName: "US", phoneNumber: cleaned };
}
